module.exports = __webpack_public_path__ + "img/binding_mb_tab_06.d2239564.png";